import { useMemo } from 'react'

import { useCatalogFiltersStore } from 'features/catalog/store'
import { useCatalogQueryStore } from 'features/catalog/yogiql-store'
import type { ChartPanel } from 'features/charts-v2/types/filter-hash/v2'
import { queryToPanel } from 'features/feedback/feedback-query'
import type { FilterOption } from 'features/filters/types'

/** The page's one panel as its v2 readers take it: the v2 store's, or under
 *  `enhanced_dialect` the held YogiQL query read against `options`. */
export function useCatalogPanel(
  yogiql: boolean,
  options: FilterOption[],
): ChartPanel {
  const v2Panel = useCatalogFiltersStore((state) => state.panels[0]!)
  const query = useCatalogQueryStore((state) => state.panels[0]!)
  return useMemo(
    () => (yogiql ? queryToPanel(query, 0, options) : v2Panel),
    [yogiql, query, options, v2Panel],
  )
}
